// extracted by mini-css-extract-plugin
export default {"container":"TemplateEditorSubject_container__kxf1g","subject":"TemplateEditorSubject_subject__vUpgc","inputContainer":"TemplateEditorSubject_inputContainer__GBbYm"};